module.exports = __webpack_public_path__ + "static/media/Monkey King.1a40e4e3.jpg";